// @ts-nocheck
import { AES, enc, mode } from 'crypto-js';
import { Utils } from '../utils';

export const encrypt = (text) => {
  const { CoreUtils } = Utils;
  const isLocalEnv = process.env.REACT_APP_ENV === 'local';

  const encryptionEnabled = process.env.REACT_APP_ENABLE_ENCRYPTION === 'true';

  const encryptionKey = process.env.REACT_APP_ENCRYPTION_SECRETE_KEY;

  if (encryptionEnabled && !CoreUtils.isValueEmpty(text)) {
    try {
      let key = enc.Utf8.parse(encryptionKey);
      let encrypted = AES.encrypt(text, key, {
        mode: mode.ECB,
      });
      encrypted = encrypted.toString();
      return encrypted;
    } catch (err) {
      throw new Error(err);
    }
  }
  return text;
};
